import React, { useState } from 'react';
import { INotificationPageProps } from './notification.type';
import { NotificationItem } from './components';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useNotification } from './notification.hook';
import Loading from '../../components/loading/loading.component';
import _ from 'lodash';
import { Spin } from 'antd';
import { EmptyComponent } from '../../components/empty/empty-component';

export const NotificationComponent: React.FC<INotificationPageProps> = (
  props
) => {
  const { onClose } = props;
  const [isAll, setIsAll] = useState<boolean>(true);
  const {
    notificationItems,
    isEndFetchingNotification,
    fetchNotification,
    isLoadingNotification,
  } = useNotification(isAll, true);
  const refreshNotifications = () => {
    fetchNotification(isAll, true);
  };
  return (
    <div className="notification-page flex rounded-lg flex-col p-4 bg-[#EDF0F3]">
      <div className="flex gap-3">
        <div
          onClick={() => setIsAll(true)}
          className={`px-4 cursor-pointer py-[10px] border text-4 leading-5 rounded-[100px] ${
            isAll ? 'text-white bg-[#0071A6]' : 'bg-white text-[#0071A6]'
          } border-[#0071A6]`}
        >
          Tất cả
        </div>
        <div
          onClick={() => setIsAll(false)}
          className={`px-4 cursor-pointer py-[10px] border text-4 leading-5 rounded-[100px] ${
            !isAll ? 'text-white bg-[#0071A6]' : 'bg-white text-[#0071A6]'
          } border-[#0071A6]`}
        >
          Chưa đọc
        </div>
      </div>
      <div className={`w-full h-full  `}>
        {isLoadingNotification ? (
          <div className="flex justify-center items-center">
            <Spin />
          </div>
        ) : notificationItems?.length > 0 ? (
          <InfiniteScroll
            dataLength={notificationItems?.length || 0}
            next={() => fetchNotification(isAll, false)}
            hasMore={false}
            loader={
              <div className="flex justify-center items-center">
                <Loading />
              </div>
            }
            endMessage={null}
            className={`flex flex-col  max-h-[calc(100vh-278px)]  `}
          >
            {_.map(notificationItems, (rc, index) => (
              <div className="w-full" key={_.get(rc, 'id', '') + index}>
                <NotificationItem
                  onClick={onClose}
                  isDropdown
                  notification={rc}
                  imageUrl={_.get(rc, 'actor.avatar')}
                  content={_.get(rc, 'message')}
                  timeStamp={_.get(rc, 'createdAt')}
                  userName={_.get(rc, 'actor.fullName')}
                  onRead={refreshNotifications}
                />
              </div>
            ))}
          </InfiniteScroll>
        ) : (
          <EmptyComponent />
        )}
      </div>
    </div>
  );
};
